import { createContext, useState, useEffect, useCallback, useContext } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useNavigate } from 'react-router-dom';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [authState, setAuthState] = useState({
    isAuthenticated: false,
    token: null,
    user: null,
  });
  const [loginError, setLoginError] = useState(null);
  const navigate = useNavigate();

  const logout = useCallback(() => {
    setAuthState({
      isAuthenticated: false,
      token: null,
      user: null,
    });
    sessionStorage.removeItem('authToken');
    navigate('/login2');
  }, [navigate]);

  useEffect(() => {
    const storedToken = sessionStorage.getItem('authToken');
    const storedEmail = sessionStorage.getItem('email');
    const storedRoles = JSON.parse(sessionStorage.getItem('roles') || '[]');

    console.log("RRR: "+storedEmail)
  
    if (storedToken) {
      try {
        setAuthState({
          isAuthenticated: true,
          token: storedToken,
          user: {
            email: storedEmail,
            roles: Array.isArray(storedRoles) ? storedRoles : [], // Ensure roles is an array
          }
        });
                  console.log("EEE: "+ JSON.stringify(authState))
      } catch (error) {
        console.error('Failed to decode stored token:', error);
        logout();
      }
    } else if (!authState.isAuthenticated) {
      navigate('/login2');
    }
  }, [navigate, authState.isAuthenticated, logout]);

  const login = (token, email, roles) => {
    console.log(`Email: ${email}`);
    if (token) {
      try {
        const decodedToken = jwtDecode(token);
        sessionStorage.setItem('authToken', token);
        sessionStorage.setItem('email', email);
        sessionStorage.setItem('roles', JSON.stringify(roles || [])); // Store roles as a JSON string
        setAuthState({
          isAuthenticated: true,
          token,
          user: {
            email: email,
            roles: roles || [], // Ensure roles is an array
          },
        });
        setLoginError(null);
      } catch (error) {
        console.error('Failed to decode token:', error);
        setLoginError('Invalid token. Please try again.');
        logout();
      }
    } else {
      setLoginError('No token provided. Please try again.');
    }
  };

  return (
    <AuthContext.Provider value={{ authState, login, logout, loginError, setLoginError }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const { authState, login, logout, loginError, setLoginError } = useContext(AuthContext);
  return {
    isAuthenticated: authState.isAuthenticated,
    email: authState.user?.email,
    roles: authState.user?.roles || null, // Assuming roles is an array
    token: authState.token,
    user: authState.user,
    login,
    logout,
    loginError,
    setLoginError,
  };
};
